import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import MaintenanceHealthBadge from 'src/components/maintenance/MaintenanceHealthBadge';

const WorkstationCard = ({ workstation, maintenanceRoute }) => (
  <div className='run-workstation-body card-base' data-testid='workstation-card'>
    <div className='run-workstation-body__header align-items-center'>
      <div className='run-workstation-body__icon icon-container'>
        <FontAwesomeIcon icon={faPrint} />
      </div>
      <div className='run-workstation-body__info info-section'>
        <h4 className='run-workstation-body__title'>{workstation.name}</h4>
        {maintenanceRoute && (
          <MaintenanceHealthBadge
            className='align-self-start mt-1'
            linkClassName='align-self-start'
            equipmentUri={workstation.uri}
            maintenanceRoute={maintenanceRoute}
          />
        )}
      </div>
    </div>
  </div>
);

WorkstationCard.propTypes = {
  workstation: PropTypes.shape({
    uri: PropTypes.string,
    name: PropTypes.string,
  }).isRequired,
  maintenanceRoute: PropTypes.string,
};

WorkstationCard.defaultProps = {
  maintenanceRoute: null,
};

export default WorkstationCard;
